import React, { useContext, useState } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import { DownArrow, UpArrow } from '../../../elem/Arrows'
import ExpandButton from '../../../elem/list/ExpandButton'
import CollapseButton from '../../../elem/list/CollapseButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { AppStateContext } from '../AppStateContext'
import { filterModes } from './FilterModeSelector'

const BoxPlotHeader = ({
    isCollapsed,
    setCollapsed,
    isExpanded,
    setIsExpanded,
}) => {
    const {
        filterMode,
        chartRef,
        loading,
        displayFilterModeDropdown,
        setDisplayFilterModeDropdown,
    } = useContext(DataContext)
    const {
        mapState: { selectedFeatures },
    } = useContext(AppStateContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Nitrate Boxplot by Well Type</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name={'NitrateBoxplotbyWellType'}
                    componentRef={chartRef}
                    disabled={
                        loading ||
                        (!selectedFeatures.length &&
                            filterMode === filterModes[0])
                    }
                />
                <div
                    className="panelButton"
                    onClick={() =>
                        setDisplayFilterModeDropdown(!displayFilterModeDropdown)
                    }
                >
                    <span className="panelTimeOptionText">{filterMode}</span>
                    <span className="panelTimeOptionDropdown">
                        {displayFilterModeDropdown ? (
                            <UpArrow color={'white'} className={'is-white'} />
                        ) : (
                            <DownArrow color={'white'} className={'is-white'} />
                        )}
                    </span>
                </div>
                {!isExpanded && (
                    <CollapseButton
                        name={`box-plot`}
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setCollapsed}
                    />
                )}
                <ExpandButton
                    name={`box-plot`}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />
            </div>
        </PanelHeader>
    )
}

export default BoxPlotHeader
